export default __webpack_public_path__ + "static/media/NIDDK_USRDS_logo.7814f32f.svg";